import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const testimonials = [
  {
    quote: "This coaching transformed not just my career, but my entire approach to leadership. I'm now leading with authenticity and seeing incredible results.",
  },
  {
    quote: "The insights I gained helped me navigate complex organizational challenges with confidence. My team's performance has never been better.",
  },
  {
    quote: "I went from feeling overwhelmed to empowered. The practical frameworks and personal development work were exactly what I needed.",
  },
  {
    quote: "Before coaching, I struggled with imposter syndrome. Now I lead with confidence and clarity.",
  },
  {
    quote: "Our managers learned how to coach their teams effectively. Productivity increased, but more importantly, trust flourished.",
  },
  {
    quote: "After our DISC workshop, communication improved overnight. We finally understood each other's strengths.",
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-heading mb-4">
            Success Stories
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Trusted by Leaders, Teams, and Organizations
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12 max-w-3xl mx-auto">
          <div className="flex items-center gap-2">
            <span className="text-accent">•</span>
            <span className="text-foreground font-medium">Confidence</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-accent">•</span>
            <span className="text-foreground font-medium">Collaboration</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-accent">•</span>
            <span className="text-foreground font-medium">Culture</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-accent">•</span>
            <span className="text-foreground font-medium">Measurable Growth</span>
          </div>
        </div>
        
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full max-w-5xl mx-auto"
        >
          <CarouselContent>
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <Card className="p-8 hover:shadow-card-hover transition-all duration-300 border-border/50 h-full">
                  <Quote className="w-10 h-10 text-accent/20 mb-4" />
                  <p className="text-muted-foreground leading-relaxed italic">
                    "{testimonial.quote}"
                  </p>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>

        <div className="flex justify-center mt-12">
          <Button 
            size="lg" 
            onClick={() => window.open('https://link.glowuplead.com/widget/service-menus/glowupleadprograms', '_blank')}
          >
            Start Creating Results Today
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
